import { useEffect, useState } from 'react';
import api from '../utils/axios';

// Acciones habilitadas del usuario en una sección (permisos v2). null mientras carga.
export const useSeccionPermisos = (modulo, seccion) => {
  const [acciones, setAcciones] = useState(null);
  useEffect(() => {
    let vivo = true;
    api.get('/permisos-v2/seccion', { params: { modulo, seccion } })
      .then((r) => vivo && setAcciones(r.data.acciones || {}))
      .catch(() => vivo && setAcciones({}));
    return () => { vivo = false; };
  }, [modulo, seccion]);
  return acciones;
};

export default useSeccionPermisos;
